var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Checkmark Circle_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15.9993 2.66699C23.3631 2.66699 29.3327 8.63653 29.3327 16.0003C29.3327 23.3641 23.3631 29.3337 15.9993 29.3337C8.63555 29.3337 2.66602 23.3641 2.66602 16.0003C2.66602 8.63653 8.63555 2.66699 15.9993 2.66699ZM20.2922 11.9599L14.3327 17.9194L11.7065 15.2932C11.3159 14.9027 10.6828 14.9027 10.2922 15.2932C9.90172 15.6837 9.90172 16.3169 10.2922 16.7074L13.6256 20.0408C14.0161 20.4313 14.6493 20.4313 15.0398 20.0408L21.7065 13.3741C22.097 12.9836 22.097 12.3504 21.7065 11.9599C21.3159 11.5694 20.6828 11.5694 20.2922 11.9599Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleFill);
export default __webpack_public_path__ + "static/media/icon-check-circle-fill.e340744e4b7bb1e7fb23592e78ab923a.svg";
export { ForwardRef as ReactComponent };